import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { Country }         from "Utils/API";

// Types
import {
    COUNTRY, COUNTRY_LOADING,
    COUNTRY_LIST, COUNTRY_ELEM,
} from "Utils/Types";



/**
 * Fetches the Country List
 * @param {Object=} params
 * @returns {(dispatch: Function) => Void}
 */
export function fetchCountries(params = {}) {
    return async (dispatch) => {
        dispatch({ type : COUNTRY_LOADING });
        Params.unset(params);
        const data = await Country.getAll(params);
        data.sort = params;
        dispatch({ type : COUNTRY_LIST, data });
        dispatch(setSection(COUNTRY));
    };
}

/**
 * Fetches a single Country
 * @param {Number} countryID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchCountry(countryID) {
    return async (dispatch) => {
        const data = await Country.getOne({ countryID });
        dispatch({ type : COUNTRY_ELEM, data });
    };
}



/**
 * Edits a Country
 * @param {Object} data
 * @returns {() => Void}
 */
export function editCountry(data) {
    return () => Country.edit(data);
}

/**
 * Deletes a Country
 * @param {Number} countryID
 * @returns {() => Void}
 */
export function deleteCountry(countryID) {
    return () => Country.delete({ countryID });
}
